import React from "react";
import moment from "moment";
import { Button, Paper } from "@material-ui/core";
import { GetApp } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles({
  tableContainer: { display: "flex", minHeight: 200 },
  dateTableWrapper: { float: "left" },
  dataTableWrapper: { float: "left", overflow: "scroll" },
  leftTable: { border: "1px solid #eee", borderCollapse: "collapse", fontSize: 13 },
  dataTable: { borderCollapse: "collapse", fontSize: 11 },
  labelCell: {
    height: 45,
    fontSize: 13,
    lineHeight: "normal",
    width: 250,
    paddingLeft: "1rem",
    borderBottom: "1px solid #eee",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    verticalAlign: "middle",
  },
  labelHeaderCell: {
    height: 39,
    width: 250,
    padding: 0,
    borderTop: "1px solid #eee6e6",
    borderBottom: "1px solid #eee6e6",
    boxSizing: "border-box",
  },
  headerCell: {
    width: 100,
    height: 39,
    padding: "0 10px",
    textAlign: "right",
    borderTop: "1px solid #eee6e6",
    borderBottom: "1px solid #eee6e6",
    whiteSpace: "nowrap",
    boxSizing: "border-box",
    verticalAlign: "middle",
  },
  dataCell: {
    minWidth: 80,
    height: 45,
    fontSize: 13,
    lineHeight: "normal",
    padding: "0 10px",
    textAlign: "right",
    borderBottom: "1px solid #eee6e6",
    borderRight: "1px solid #eee6e6",
    boxSizing: "border-box",
    verticalAlign: "middle",
  },
});

const rows = [
  ["countReportWithPhoto", "画像あり報告数"],
  ["countReportWithoutPhoto", "画像なし報告数"],
  ["countReviewOk", "レビューOK機数"],
  ["unique", "撮影者数"],
];

const PhotoShootTableCommon = ({ photoShootTrend, chartSize }) => {
  const classes = useStyles();
  const data = photoShootTrend?.[0];
  const dates = data?.date || [];
  const csvData = [
    ["避難訓練撮影データ", ...dates.map((date) => (
      chartSize === "hour" ? moment(date).format("M/D HH:mm") : moment(date).format("M/D")
    ))],
    ...rows.map(([key, label]) => [label, ...(data?.[key] || [])]),
  ];

  return (
    <Paper>
      <div style={{ display: "flex", justifyContent: "flex-end", padding: 16 }}>
        <CSVLink data={csvData} filename="PicTree-避難訓練撮影トレンドデータ">
          <Button variant="contained" startIcon={<GetApp />}>CSV出力</Button>
        </CSVLink>
      </div>
      {dates.length > 0 ? (
        <div className={classes.tableContainer}>
          <div className={classes.dateTableWrapper}>
            <table className={classes.leftTable}>
              <tbody>
                <tr><td className={classes.labelHeaderCell} /> </tr>
                {rows.map(([, label]) => (
                  <tr key={label}><td className={classes.labelCell}>{label}</td></tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className={classes.dataTableWrapper}>
            <table className={classes.dataTable}>
              <tbody>
                <tr>
                  {dates.map((date) => (
                    <td className={classes.headerCell} key={date}>
                      {chartSize === "hour" ? moment(date).format("M/D HH:mm") : moment(date).format("M/D")}
                    </td>
                  ))}
                </tr>
                {rows.map(([key, label]) => (
                  <tr key={label}>
                    {(data[key] || []).map((value, index) => (
                      <td className={classes.dataCell} key={`${key}-${index}`}>{value}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : null}
    </Paper>
  );
};

export default PhotoShootTableCommon;
